import Dashboard from './pages/dashboard';
import Header from './general/header';
import Footer from './general/footer';
import { getGarminConnectToken } from '../services/user';

export default function Home() {
    const sp = new URLSearchParams(window.location.search);

    const code_verifier = localStorage.getItem('code_verifier');

    const code = sp.get('code');
    if (code) {
        getGarminConnectToken(code, code_verifier ?? '')
            .then(response => {
                if (response.data.status == 1) {
                    window.location.href = window.location.href.split("?")[0];
                }
            })
            .catch(whoamiError => {
                console.log(whoamiError);
            });
    }

    return (
        <div className="home-content">
            <div id="page">
                <Header />
                <Dashboard />
                <Footer />
            </div>
        </div>
    );
}
